import React, { useEffect, useState } from 'react';
// import SingleUserLayout from '../SingleUserLayout';
import Pagination from '../../../../../../../components/common/pagination';
import { debounce } from 'lodash';
import SmartFilter from '../../../../../../../components/common/smartFilter';
import BadgeComponent from '../../../../../../../components/common/badge/BadgeComponent';
import ravenlogo from '../../../../../../../assets/raven-small-logo-green.svg';
import visaIcon from '../../../../../../../assets/visa-icon.svg';
import verveIcon from '../../../../../../../assets/verve-icon.svg';
import masterIcon from '../../../../../../../assets/master-icon.svg';
import DateFragmentBox from '../../../../../../../components/common/DateFragmentBox';
import {
	capitalizeFirstLetter,
	capitalizeFirstWord,
	colorToRgba,
	convertToHumanReadable,
	detectCardType,
	downloadCsvFile,
	formatDateHelper,
	formatDateTime,
	formatMetaData,
	formatNumWithComma,
	formatTypeFunction,
	maskCardNumber,
	returnInitial,
	symbol,
	trimLongString,
} from '../../../../../../../utils/helper/Helper';
import {
	RavenBadge,
	RavenCopyText,
	RavenNumberFormat,
	RavenTable,
	RavenTableRow,
	RavenToolTip,
} from '@ravenpay/raven-bank-ui';
// import { bankboxAPI } from '../../../../../../redux/bankbox';
import { useDispatch, useSelector } from 'react-redux';
import RootState from '../../../../../../../redux/types';
import { bankboxAPI } from '../../../../../../../redux/bankbox';
import EmptyScreen from '../../../../../../../components/common/emptyScreen';
import Skeleton from 'react-loading-skeleton';
import TwoDetailView from '../../../../../../../components/common/TwoDetailView';
import ExportModal from '../../../../../../../components/common/exportModal';
import TransactionModal from '../../../../../../../components/common/transactionModal';
import CheckUrlFragment from '../../../../../../../components/common/CheckUrlCodeFragment';

const Transaction = () => {
	const dispatch = useDispatch();
	const [showExport, setShowExport] = useState<boolean>(false);
	const [currentPage, setCurrentPage] = useState(1);
	const merchant_email = localStorage?.getItem('merchant-email-user-preview');
	const [searchData, setSearchData] = useState([]);

	const { user_merchant, all_merchant_bankbox_trx, loading_roles } =
		useSelector((state: RootState) => state.bankbox);
	const [view, onView] = useState<any>({
		show: false,
		view: '',
	});
	// '------', all_merchant_bankbox_trx;
	//fetch transfers
	useEffect(() => {
		if (Object?.keys(user_merchant)?.length > 0 && merchant_email) {
			getMerchantAllTransaction();
		}
	}, [currentPage, user_merchant]);

	const getMerchantAllTransaction = async () => {
		dispatch(
			bankboxAPI.getMerchantAllTransactions({
				page: currentPage,
				per_page: 20,
				search: merchant_email,
				email: merchant_email,
			})
		);
	};

	const bankIcon = (
		<svg
			className="img"
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M30.1895 14.9425C30.189 14.6126 30.1107 14.2874 29.961 13.9933C29.8114 13.6993 29.5945 13.4446 29.328 13.25L19.622 6.16453C19.2682 5.90658 18.8426 5.76569 18.4047 5.76157C17.9669 5.75744 17.5387 5.89029 17.18 6.14153L7.04452 13.25C6.76854 13.4435 6.54318 13.7006 6.38749 13.9995C6.2318 14.2985 6.15035 14.6305 6.15002 14.9675C6.14996 15.0782 6.1717 15.1878 6.21401 15.2901C6.25632 15.3924 6.31837 15.4853 6.39661 15.5636C6.47485 15.6419 6.56775 15.704 6.67 15.7464C6.77225 15.7887 6.88184 15.8105 6.99252 15.8105H29.322C29.436 15.8105 29.5488 15.7881 29.6541 15.7445C29.7594 15.7008 29.8551 15.6369 29.9356 15.5563C30.0162 15.4757 30.0801 15.38 30.1236 15.2747C30.1672 15.1694 30.1896 15.0565 30.1895 14.9425Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M6.15002 27.1804V28.2804C6.15002 28.8374 6.37127 29.3715 6.7651 29.7653C7.15893 30.1592 7.69307 30.3804 8.25002 30.3804H28.0915C28.6485 30.3804 29.1826 30.1592 29.5764 29.7653C29.9703 29.3715 30.1915 28.8374 30.1915 28.2804V27.1804H6.15002Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M18.6415 16.6289H17.6995C17.0017 16.6289 16.436 17.1946 16.436 17.8924V25.0569C16.436 25.7547 17.0017 26.3204 17.6995 26.3204H18.6415C19.3393 26.3204 19.905 25.7547 19.905 25.0569V17.8924C19.905 17.1946 19.3393 16.6289 18.6415 16.6289Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M25.5335 16.6289H24.5915C23.8937 16.6289 23.328 17.1946 23.328 17.8924V25.0569C23.328 25.7547 23.8937 26.3204 24.5915 26.3204H25.5335C26.2313 26.3204 26.797 25.7547 26.797 25.0569V17.8924C26.797 17.1946 26.2313 16.6289 25.5335 16.6289Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M11.7494 16.6289H10.8074C10.1096 16.6289 9.54395 17.1946 9.54395 17.8924V25.0569C9.54395 25.7547 10.1096 26.3204 10.8074 26.3204H11.7494C12.4473 26.3204 13.0129 25.7547 13.0129 25.0569V17.8924C13.0129 17.1946 12.4473 16.6289 11.7494 16.6289Z"
				fill="var(--primary-base-color)"
			/>
		</svg>
	);

	const csvHeader = [
		{ label: 's/n', key: 'sn' },
		{ label: 'terminal ID', key: 'id' },
		{ label: 'direction', key: 'direction' },
		{ label: 'system_reference', key: 'system_reference' },
		{ label: 'business_email', key: 'business_email' },
		{ label: 'type', key: 'type' },
		{ label: 'amount', key: 'amount' },
		{ label: 'credited_amount', key: 'credited_amount' },
		{ label: 'merchant_settlement', key: 'merchant_settlement' },
		{ label: 'fee', key: 'fee' },
		{ label: 'platform_fee', key: 'platform_fee' },
		{ label: 'balance_before', key: 'balance_before' },
		{ label: 'balance_after', key: 'balance_after' },
		{ label: 'stamp_duty', key: 'stamp_duty' },
		{ label: 'terminal_label', key: 'terminal_label' },
		{ label: 'transaction_reference', key: 'tranx_reference' },
		{ label: 'transaction_details', key: 'transaction_details' },
		{ label: 'provider', key: 'provider' },
		{ label: 'date', key: 'created_at' },
		{ label: 'status', key: 'status' },
	];
	const formatExportData = (param: any) => {
		if (param?.length > 0) {
			const newData = param?.map((chi: any, idx: any) => {
				return {
					sn: idx + 1 < 10 ? `0${idx + 1}` : idx + 1,
					id: chi?.t_id || 'NIL',
					direction: chi?.direction
						? capitalizeFirstLetter(chi?.direction)
						: 'NIL',
					system_reference: chi?.reference || 'NIL',
					business_email:
						formatMetaData(chi?.pdon_meta)?.terminal?.poseidon_business_email ||
						chi?.business_email ||
						'NIL',
					type:
						chi?.type === 'pdon_card'
							? `card_payment`
							: formatTypeFunction(chi?.type) || 'NIL',
					amount: RavenNumberFormat(chi?.amount) || 'NIL',
					credited_amount: RavenNumberFormat(chi?.credited_amount),
					merchant_settlement: RavenNumberFormat(chi?.merchant_settlement),
					fee: RavenNumberFormat(chi?.fee) || 'NIL',
					platform_fee: RavenNumberFormat(chi?.platform_fee),
					balance_before: RavenNumberFormat(chi?.b_before) || 'NIL',
					balance_after: RavenNumberFormat(chi?.b_after) || 'NIL',
					stamp_duty: RavenNumberFormat(chi?.stamp_duty) || 'NIL',
					serial:
						chi?.serial ||
						formatMetaData(chi?.pdon_meta)?.terminal?.serial ||
						'NIL',
					terminal_label:
						formatMetaData(chi?.pdon_meta)?.terminal?.tid_label || 'NIL',
					tranx_reference:
						chi?.type === 'transfer_in'
							? formatMetaData(chi?.meta_data)?.session_id
							: chi?.rrn || 'NIL',
					transaction_details:
						chi?.type === 'transfer_in'
							? `Account Name: ${
									formatMetaData(chi?.meta_data)?.source?.first_name || ''
							  } ${
									formatMetaData(chi?.meta_data)?.source?.last_name || ''
							  }, Account Number: ${
									formatMetaData(chi?.meta_data)?.source?.account_number
							  } ,  Bank: ${formatMetaData(chi?.meta_data)?.source?.bank} `
							: chi?.type === 'pdon_card' && !chi?.meta_data
							? maskCardNumber(formatMetaData(chi?.pdon_meta)?.card?.card_pan)
							: `${chi?.stan}`,
					// provider:
					// chi?.provider  || "NIL",
					created_at: chi?.created_at
						? formatDateHelper(chi?.created_at)?.replace('—', '•')
						: 'NIL',
					status: String(chi?.status) === '00' ? `Success` : `Failed`,
				};
			});

			downloadCsvFile(csvHeader, newData, 'transaction_data.csv');
		}
	};

	function formatStatus(status: string | number, type?: string) {
		// console.log(status);
		// let

		if (type === 'card') {
			if (String(status) === '00') return 'successful';
			return 'failed';
		}

		if (type === 'transfer_in') {
			if (status === 3) return 'successful';
			if (status === 1) return 'pending';
			return 'failed';
		}

		return 'Failed';
	}

	function formatStatusColor(status: string | number, type?: string) {
		if (type === 'card') {
			if (status === '00') return 'green';
			return 'red';
		}

		if (type === 'transfer_in') {
			if (status === 3) return 'green';
			if (status === 1) return 'yellow';
			return 'red';
		}

		return 'gray';
	}

	const getImageCardFunc = (param: any) => {
		let val;
		if (param) {
			const checkText =
				detectCardType(param) === 'Visa'
					? visaIcon
					: detectCardType(param) === 'Master'
					? masterIcon
					: verveIcon;
			val = checkText;
		}
		return val;
	};

	const handlesearch = (e: any) => {
		dispatch(
			bankboxAPI.getMerchantAllTransactions({
				per_page: 20,
				page: currentPage,
				search: e,
			})
		);
		// setSearchData(all_single_disputes?.data?.transactions);
	};
	// ('search', searchData);
	// (all_single_disputes?.data);

	useEffect(() => {
		if (Array.isArray(all_merchant_bankbox_trx?.data)) {
			setSearchData(all_merchant_bankbox_trx.data);
		}
	}, [all_merchant_bankbox_trx]);

	return (
		<>
			{/* dispute content start */}
			<div
				style={{ marginBottom: '1.5rem' }}
				className="global-search-pagination-filter-box"
				// onClick={() => {
				// 	//(all_merchant_bankbox_trx);
				// }}
			>
				{' '}
				<SmartFilter
					searchTitle="Search by RRN"
					defaultFilterBy="status"
					onSearchChange={debounce((e) => {
						handlesearch(e);
					}, 500)}
					filters={[
						{
							label: 'Status',
							filterBy: 'status',
							options: [
								{
									label: 'Pending',
									value: '0',
								},
								{
									label: 'Successful',
									value: '3',
								},
								{
									label: 'Failed',
									value: '2',
								},
								{
									label: 'All',
									value: 'reset',
								},
							],
						},
					]}
					filtersTwo={[
						{
							label: 'Type',
							filterBy: 'type',
							options: [
								{
									label: 'Card',
									value: 'pdon_card',
								},
								{
									label: 'Transfer In',
									value: 'transfer_in',
								},
								// {
								// 	label: 'Transfer Out',
								// 	value: 'transfer_out',
								// },
								{
									label: 'All',
									value: 'reset',
								},
							],
						},
					]}
					onExport={() => setShowExport(true)}
					page="mtransactions"
				/>
				<div className="pagination-wrap">
					{' '}
					<Pagination
						className="top-bar__pagination"
						currentPage={currentPage}
						itemsPerPage={all_merchant_bankbox_trx?.perPage ?? 0}
						totalItems={all_merchant_bankbox_trx?.total ?? 0}
						onPageChange={function (page: number): void {
							setCurrentPage(page);
						}}
					/>
				</div>
			</div>

			{/* dispute content end */}
			<div
				style={{ minHeight: '45rem' }}
				className="transaction__table non-mobile"
			>
				{loading_roles ||
				!all_merchant_bankbox_trx ||
				!all_merchant_bankbox_trx?.data ||
				all_merchant_bankbox_trx?.data?.length < 1 ? (
					<EmptyScreen
						loading={loading_roles}
						loadingText={
							loading_roles ? 'Searching...' : 'Loading Transactions...'
						}
						title="No Merchant Transaction Found"
						subTitle="You don't have any record yet,your new bankbox transactions will be displayed here."
					/>
				) : (
					<>
						<RavenTable
							action={false}
							// className="table__main"
							headerList={[
								'Details',
								'Type',
								'Amount',
								'Merchant',
								'Status',
								'Transaction Date',
							]}
						>
							<>
								{' '}
								{all_merchant_bankbox_trx?.data?.map(
									(chi: any, idx: number) => {
										//(all_merchant_bankbox_trx);
										const meta = JSON.parse(chi.meta_data);
										const pdon = JSON.parse(chi.pdon_meta);

										return (
											<React.Fragment key={idx}>
												<RavenTableRow
													onRowClick={() => {
														onView({
															show: true,
															content: {
																...chi,
																meta_data: meta,
																pdon_meta: pdon,
															},
														});
														// console.log(pdon);
														// console.log(meta);
														// console.log(chi);
													}}
													// loading={loading_roles}
													className="table__main"
													five={
														loading_roles ? (
															<Skeleton
																style={{ borderRadius: '10px' }}
																width={80}
																height={20}
															/>
														) : (
															<div className="tooltip-hover-wrap">
																{/* {formatStatus(meta?.response_code)} */}
																<RavenBadge
																	text={
																		chi?.status === '00' ? 'success' : 'failed'
																	}
																	type={chi?.status === '00' ? 'green' : 'red'}
																/>
																{formatMetaData(chi?.pdon_meta)?.card
																	?.response_meaning && (
																	<RavenToolTip
																		color="deep-green-light"
																		text={
																			formatMetaData(chi?.pdon_meta)?.card
																				?.response_meaning
																		}
																		position={`left`}
																	/>
																)}
															</div>
														)
													}
													six={
														loading_roles ? (
															<Skeleton width={100} height={20} />
														) : (
															// formatDateTime(chi?.created_at)
															<DateFragmentBox date={chi?.created_at} />
														)
													}
													two={
														loading_roles ? (
															<Skeleton width={100} height={20} />
														) : chi?.type ? (
															convertToHumanReadable(chi?.type)?.replace(
																'Pdon',
																''
															)
														) : (
															'---'
														)
													}
													four={
														<div
															style={{ zIndex: '10', position: 'relative' }}
															className="account_name--transfer"
														>
															{loading_roles ? (
																<Skeleton circle width={35} height={35} />
															) : (
																<span
																	className="account_name__span grey-bg-two"
																	style={{
																		backgroundColor:
																			// generateRandomColor('#e9f5ff'),
																			'var(--primary-accent-color-one)',
																	}}
																>
																	<p>
																		{returnInitial(chi?.business_email || '--')}
																	</p>
																</span>
															)}

															{loading_roles ? (
																<Skeleton width={230} height={20} />
															) : (
																<div className="bankbox-trx-tbl-name">
																	<p className="text">
																		{' '}
																		{chi?.business_email || '--'}
																	</p>
																	{chi.type === 'transfer_in' ? (
																		<p>
																			{chi?.account_number}{' '}
																			{pdon?.terminal?.tid_label}
																		</p>
																	) : (
																		<p>
																			{chi?.serial} •{' '}
																			{
																				pdon?.terminal_profile
																					?.poseidon_business_name
																			}
																		</p>
																	)}
																</div>
															)}
														</div>
													}
													one={
														loading_roles ? (
															<div
																style={{
																	display: 'flex',
																	alignItems: 'center',
																	gap: '1rem',
																}}
																className="type-wrap"
															>
																<Skeleton circle width={35} height={35} />
																<div>
																	<Skeleton width={100} height={17} />
																	<Skeleton
																		style={{ marginTop: '.5rem' }}
																		width={250}
																		height={12}
																	/>
																</div>
															</div>
														) : (
															<div className="type-wrap">
																<TwoDetailView
																	loading={loading_roles}
																	imgComponent={
																		<CheckUrlFragment
																			className="img-box-bank-card-logo border-theme"
																			url={
																				chi?.type === 'transfer_in'
																					? `https://businessapi.getraventest.com/static/media/banks/${meta?.source?.bank_code}.png`
																					: chi?.type === 'pdon_card' &&
																					  chi?.meta_data
																					? getImageCardFunc(
																							formatMetaData(chi?.meta_data)
																								?.card_pan
																					  )
																					: chi?.type === 'pdon_card' &&
																					  !chi?.meta_data
																					? getImageCardFunc(
																							formatMetaData(chi?.pdon_meta)
																								?.card?.card_pan
																					  )
																					: ''
																			}
																		>
																			{meta?.source?.bank_code === '090615' ? (
																				<figure className="img-box-bank-card-logo">
																					<img
																						src={ravenlogo}
																						alt=""
																						className="img"
																					/>
																				</figure>
																			) : (
																				<figure className="img-box-bank-card-logo  border-theme">
																					{bankIcon}
																				</figure>
																			)}
																		</CheckUrlFragment>
																	}
																	title={
																		chi?.type === 'transfer_in'
																			? `${meta?.source?.first_name || '---'} ${
																					meta?.source?.last_name || '---'
																			  }`
																			: formatMetaData(chi?.pdon_meta)
																					?.card_meta?.card_pan || '---'
																	}
																	text_one={
																		chi?.type === 'transfer_in'
																			? `${trimLongString(
																					meta?.source?.bank || '---',
																					22
																			  )} • ${
																					meta?.source?.account_number || '---'
																			  }`
																			: ((
																					<RavenCopyText
																						stopPropagation
																						copyIconColor="var(--primary-base-color)"
																						copyIconBgColor={colorToRgba(
																							'var(--primary-base-color)',
																							0.1
																						)}
																						copiedBgColor=" var(--primary-base-color)"
																						text={`RRN: ${chi?.rrn || '---'}`}
																						copyValue={chi?.rrn}
																					/>
																			  ) as any)
																	}
																/>
															</div>
														)
													}
													three={
														loading_roles ? (
															<Skeleton width={100} height={20} />
														) : (
															symbol('ngn') +
															formatNumWithComma(chi?.amount, 'ngn')
														)
													}
												/>
											</React.Fragment>
										);
									}
								)}
							</>
						</RavenTable>
					</>
				)}
			</div>

			<ExportModal
				onClose={() => setShowExport(false)}
				visible={showExport}
				page="merchant_transactions"
				onFinishExport={(param) => {
					formatExportData(param);
					//window.open(param, '_blank')?.focus();
				}}
			/>

			<TransactionModal
				// details={view?.content}
				isLoadingDetails={true || '---'}
				status={view?.content?.status === '00' ? 'success' : 'failed'}
				reference={view?.reference}
				transactionType={view?.transactionType}
				onClose={() => {
					// //(view?.content);

					onView({
						show: false,
						content: {
							type: '',
							bank: '',
							description: '',
							amount: '',
							date: '',
							session_id: '',
							account_number: '',
							email: '',
							created_at: function (created_at: any): string {
								throw new Error('Function not implemented.');
							},
							updated_at: function (updated_at: any): string {
								throw new Error('Function not implemented.');
							},
						},
						on: false,
					});
				}}
				singleObj={view?.content}
				visible={view.show}
				direction={view?.content?.direction}
				title={'Transactions Details'}
				amountt={view?.content?.amount as unknown as number}
				onClick={() => {}}
				meta={JSON.stringify({
					...view?.content?.meta_data,
					...view?.content?.pdon_meta,
				})}
				content={
					view?.content?.type === 'transfer_in'
						? [
								{
									label: 'Narration',
									value: view?.content?.meta_data?.source?.narration || '--',
								},
								{
									label: 'Amount',
									value:
										symbol('ngn') +
										formatNumWithComma(view?.content?.amount, 'ngn'),
								},
								{
									label: 'Fee',
									value:
										symbol('ngn') +
										formatNumWithComma(view?.content?.fee, 'ngn'),
								},
								// {
								// 	label: 'Bank',
								// 	value: formatMetaData(view?.content?.meta_data)?.bank || '--',
								// },
								// {
								// 	label: 'Account Name',
								// 	value:
								// 		`${view?.content?.meta_data?.source?.first_name || ''} ${
								// 			view?.content?.meta_data?.source?.last_name || ''
								// 		}`.trim() || '--',
								// },
								// {
								// 	label: 'Account Number',
								// 	value:
								// 		view?.content?.meta_data?.source?.account_number || '--',
								// 	copy: true,
								// 	trim: true,
								// },
								{
									label: 'Merchant Reference',
									value: view?.content?.reference || '--',
									copy: true,
								},
								{
									label: 'Card Pan',
									value:
										view?.content?.pdon_meta?.card_meta?.card_pan ||
										maskCardNumber(view?.content?.pdon_meta?.card?.card_pan) ||
										'--',
									copy: true,
									trim: true,
								},
								{
									label: 'Terminal ID',
									value: view?.content?.t_id || '--',
									copy: true,
									trim: true,
								},

								{
									label: 'Session ID',
									value: view?.content?.meta_data?.session_id || '--',
									copy: true,
									trim: true,
								},

								{
									label: 'Reason',
									value: view?.content?.pdon_meta?.card?.response_meaning
										? view?.content?.pdon_meta?.card?.response_meaning
										: '--',
									// copy: true,
									dontSHow: view?.content?.pdon_meta?.card?.response_meaning
										? false
										: true,
								},
								{
									label: 'Created At',
									value: formatDateTime(
										view?.content?.created_at as unknown as string
									),
								},
						  ]
						: [
								{
									label: 'Serial',
									value: view?.content?.serial || '--',
								},
								{
									label: 'Amount',
									value:
										symbol('ngn') +
										formatNumWithComma(view?.content?.amount, 'ngn'),
								},
								{
									label: 'Fee',
									value:
										symbol('ngn') +
										formatNumWithComma(view?.content?.fee, 'ngn'),
								},
								{
									label: 'Issuing App',
									value:
										view?.content?.pdon_meta?.terminal_profile?.issuing_app ||
										'--',
								},
								{
									label: 'Business Email',
									value:
										view?.content?.pdon_meta?.terminal_profile
											?.poseidon_owner_email || '--',
								},
								{
									label: 'Business Name',
									value:
										view?.content?.pdon_meta?.terminal_profile
											?.poseidon_business_name || '--',
								},
								{
									label: 'Serial Number',
									value:
										view?.content?.pdon_meta?.terminal_profile
											?.poseidon_serial_number || '--',
									copy: true,
									trim: true,
									// dontSHow: true,
								},
								{
									label: 'Terminal ID',
									value: view?.content?.t_id || '--',
									copy: true,
									trim: true,
								},
								{
									label: 'Card Pan',
									value:
										view?.content?.pdon_meta?.card_meta?.card_pan ||
										maskCardNumber(view?.content?.pdon_meta?.card?.card_pan) ||
										'--',
									copy: true,
									trim: true,
								},
								{
									label: 'RRN',
									value: view?.content?.rrn || '--',
									copy: true,
									trim: true,
								},
								{
									label: 'Stan',
									value: view?.content?.stan || '--',
									copy: true,
									trim: true,
								},
								{
									label: 'Merchant Reference',
									value: view?.content?.reference || '--',
									copy: true,
								},

								{
									label: 'Reason',
									value: view?.content?.pdon_meta?.card?.response_meaning
										? view?.content?.pdon_meta?.card?.response_meaning
										: '--',
									// copy: true,
									dontSHow: view?.content?.pdon_meta?.card?.response_meaning
										? false
										: true,
								},
								{
									label: 'BankBox Label',
									value:
										view?.content?.pdon_meta?.terminal_profile
											?.poseidon_label || '--',
								},
								{
									label: 'Created At',
									value: formatDateTime(
										view?.content?.created_at as unknown as string
									),
								},
						  ]
				}
			/>
		</>
	);
};

export default Transaction;
